var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 0H7.98424C7.66347 0 7.21513 0.185834 6.98849 0.412307L0.340453 7.06031C-0.113484 7.51373 -0.113484 8.25714 0.340453 8.71001L5.29046 13.6598C5.74337 14.1133 6.48605 14.1133 6.93965 13.6593L13.5877 7.01236C13.8141 6.78592 14 6.33687 14 6.01678V1.16672C14 0.525167 13.4748 0 12.8333 0ZM10.4998 4.66669C9.85546 4.66669 9.3331 4.14378 9.3331 3.49997C9.3331 2.85511 9.85546 2.33326 10.4998 2.33326C11.1442 2.33326 11.6667 2.85511 11.6667 3.49997C11.6667 4.14378 11.1442 4.66669 10.4998 4.66669Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillTag);
export default __webpack_public_path__ + "static/media/fillTag.06aa6c459b16890f4c2f229d155c47b5.svg";
export { ForwardRef as ReactComponent };